import Text from '@deprecated-ui/common/Text';
import Button from '@deprecated-ui/common/Button';
import color from '@deprecated-ui/_style/color';
import useForm from 'hooks/useForm';
import PropTypes from 'prop-types';
import { selectors as profileSelector } from 'lib/entities/profile';
import { effects as moderationEffects } from 'lib/entities/moderation';
import { useDispatch, useSelector } from 'react-redux';
import { isAllowedToBlockIp } from 'utils/userRole';
import { useEffect, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import QueryProvider from 'global/QueryProvider';
import { defaultReportLabel } from 'global/StreamWidget/constants';
import {
  BLOCK_DURATION,
  BLOCK_NO_VOTE,
  BLOCK_TYPES,
  reportOptions,
} from '../constants';
import { Modal, Select, Option } from './styled';

function ModalSuspendUser({
  username,
  userId,
  postId,
  onCancel,
  onSubmit,
  ...props
}) {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const { data: dataProfile } = useSelector(profileSelector);
  const { user_priv: privilege } = dataProfile;

  const [suspendType, setSuspendType] = useForm({ initialState: 2 });
  const [duration, setDuration] = useForm({ initialState: '0' });
  const [reason, setReason] = useForm({ initialState: defaultReportLabel });
  const [sendEmail, setSendEmail] = useState(false);
  const [blockIp, setBlockIp] = useState(false);
  const [isAllowBlockIp, setIsAllowBlockIp] = useState(false);

  const suspendTypeOptions = isAllowedToBlockIp(privilege)
    ? [...BLOCK_TYPES, BLOCK_NO_VOTE]
    : [...BLOCK_TYPES];

  const toggleSendEmail = () => {
    setSendEmail(!sendEmail);
  };

  const toggleBlockIp = () => {
    setBlockIp(!blockIp);
  };

  const handleSuspend = async () => {
    const data = {
      blockmode: suspendType,
      duration,
      reason,
      userid: userId,
      postid: postId,
      sendEmail,
      blockIp,
    };

    const suspend = await dispatch(moderationEffects.suspendUser(data));
    queryClient.invalidateQueries();
    const { error } = suspend.payload;

    if (!error) {
      onSubmit?.();
      onCancel();
    }
  };

  useEffect(() => {
    setIsAllowBlockIp(isAllowedToBlockIp(privilege));
  }, [privilege]);

  return (
    <Modal
      {...props}
      onCancel={onCancel}
      title={
        <Text size="16px" height="40px" weight="bold" color={color.black}>
          Mute @{username}
        </Text>
      }
      width={280}
      centered
      footer={[
        <Button key="cancel" block height="40px" onClick={onCancel}>
          <Text align="center">Cancel</Text>
        </Button>,
        <Button
          key="confirm"
          block
          type="primary"
          height="40px"
          margin="0px !important"
          onClick={handleSuspend}
        >
          <Text align="center" color={color.light}>
            Confirm
          </Text>
        </Button>,
      ]}
    >
      <Text size="12px">Block Reason : </Text>
      <Select value={suspendType} onChange={setSuspendType}>
        {suspendTypeOptions.map(({ key, label }) => (
          <Option key={key} value={key}>
            {label}
          </Option>
        ))}
      </Select>
      <Text size="12px" mt="5px">
        Mute Reason :{' '}
      </Text>
      <Select value={reason} onChange={setReason}>
        {reportOptions.map(({ key, label }) => (
          <Option key={key} value={label}>
            {label}
          </Option>
        ))}
      </Select>
      <Text size="12px" mt="5px">
        Duration Suspend:{' '}
      </Text>
      <Select value={duration} onChange={setDuration}>
        {BLOCK_DURATION.map(({ label, value }) => (
          <Option key={value} value={value}>
            {label}
          </Option>
        ))}
      </Select>
      <Text size="12px">Send report to user?</Text>
      <input type="checkbox" checked={sendEmail} onChange={toggleSendEmail} />
      {isAllowBlockIp && (
        <>
          <Text size="12px">Block IP?</Text>
          <input type="checkbox" checked={blockIp} onChange={toggleBlockIp} />
        </>
      )}
    </Modal>
  );
}

ModalSuspendUser.propTypes = {
  username: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  postId: PropTypes.number.isRequired,
  onCancel: PropTypes.func,
  onSubmit: PropTypes.func,
};

ModalSuspendUser.defaultProps = {
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onCancel: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onSubmit: () => {},
};

function ModalSuspendUserWithQuery({
  username,
  userId,
  postId,
  onCancel,
  onSubmit,
  ...props
}) {
  return (
    <QueryProvider>
      <ModalSuspendUser
        username={username}
        userId={userId}
        onCancel={onCancel}
        postId={postId}
        onSubmit={onSubmit}
        {...props}
      />
    </QueryProvider>
  );
}

export default ModalSuspendUserWithQuery;
